import { HELP_TOPICS, SEARCH_OPERATORS } from '../../lib/help.js'
import { keyGroups } from '../../lib/keys.js'
import { routeHref } from '../../lib/router.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- tpl-help ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    topic: { type: String, default: 'start' },
  }

  init() {
    this.state.tabs = HELP_TOPICS.map((topic) => ({ id: topic.id, label: topic.menu || topic.title, icon: topic.icon, href: routeHref('help', { topic: topic.id === 'start' ? '' : topic.id }) }))
    this.state.operators = SEARCH_OPERATORS.map(([operator, meaning, example]) => ({ operator, meaning, example }))
    this.state.keyGroups = keyGroups()
  }

  onRefresh(props, changed) {
    // Hash routes keep the scroll position; a new topic starts at its top.
    if ('topic' in changed) this.root.closest('main')?.scrollTo({ top: 0 })
  }

  beforeRender() {
    this.state.current = HELP_TOPICS.find((topic) => topic.id === this.props.topic) || HELP_TOPICS[0]
  }

  CSS = `:fez {
display:block;.help-page{max-width:calc(var(--content-width) + 240px);margin:0 auto;padding:var(--space-10) var(--space-6) var(--space-12);:mobile {padding:var(--space-6) var(--space-4) var(--space-10)}}.help-crumb{color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.help-layout{display:grid;grid-template-columns:200px minmax(0,1fr);gap:var(--space-8);margin-top:var(--space-6);:mobile {grid-template-columns:minmax(0,1fr);gap:var(--space-5)}}.help-menu{position:sticky;top:var(--space-6);align-self:start;:mobile {position:static}}.help-title{font-size:var(--text-2xl);letter-spacing:-0.02em}.help-lead{margin-top:var(--space-2);color:var(--color-text-muted);font-size:var(--text-md)}.help-section{margin-top:var(--space-8)}.help-section-title{margin-bottom:var(--space-2);font-size:var(--text-lg)}.help-text{line-height:1.6;p + p{margin-top:var(--space-3)}p + ul,ul + p{margin-top:var(--space-3)}ul{display:grid;gap:var(--space-1);padding-left:var(--space-5)}code{padding:1px 5px;border-radius:var(--radius-sm);background:var(--color-bg-subtle)}}.help-table{width:100%;margin-top:var(--space-6);border-collapse:collapse;font-size:var(--text-sm);th{padding:var(--space-2) var(--space-3);border-bottom:1px solid var(--color-border);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-align:left;text-transform:uppercase}td{padding:var(--space-2) var(--space-3);border-bottom:1px solid var(--color-border);vertical-align:top}.help-op{font-family:var(--font-mono);font-weight:var(--weight-semibold);white-space:nowrap}.help-example{color:var(--color-text-muted);font-family:var(--font-mono);white-space:nowrap} :mobile {.help-example{display:none}}}.help-keys{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:var(--space-6);margin-top:var(--space-6)}.help-keys-title{margin-bottom:var(--space-2);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.help-keys-row{display:flex;align-items:center;justify-content:space-between;gap:var(--space-3);padding:var(--space-2) 0;border-bottom:1px solid var(--color-border);font-size:var(--text-sm)}.help-api{display:flex;align-items:center;gap:var(--space-2);margin-top:var(--space-3);padding:var(--space-2) var(--space-3);border-top:1px solid var(--color-border);color:var(--color-text-muted);font-size:var(--text-sm);font-weight:var(--weight-semibold);text-decoration:none;&:hover{color:var(--color-text);text-decoration:none} :mobile {border-top:0}}
}`

  HTML = `<div class="help-page">
<div class="help-crumb">Help</div>
<div class="help-layout">
<div class="help-menu">
<ui-tabs vertical :tabs="state.tabs" active={state.current.id}></ui-tabs>
<a class="help-api" href="/api" target="_blank" rel="noopener"><ui-icon name="code" size="16"></ui-icon>API reference<ui-icon name="arrow-square-out" size="14"></ui-icon></a>
</div>
<article>
<h1 class="help-title">{state.current.title}</h1>
<p class="help-lead">{state.current.lead}</p>
{#if state.current.operators}
<table class="help-table">
<thead><tr><th>Type</th><th>Finds</th><th class="help-example">Example</th></tr></thead>
<tbody>
{#each state.operators as row}
<tr key={row.operator}><td class="help-op">{row.operator}</td><td>{row.meaning}</td><td class="help-example">{row.example}</td></tr>
{/each}
</tbody>
</table>
{/if}
{#if state.current.keys}
<div class="help-keys">
{#each state.keyGroups as group}
<section>
<h3 class="help-keys-title">{group.title}</h3>
{#each group.keys as item}
<div class="help-keys-row">
<span>{item.label}</span>
<ui-kbd keys={item.keys}></ui-kbd>
</div>
{/each}
</section>
{/each}
</div>
{/if}
{#each state.current.sections as section}
<section class="help-section" key={section.title}>
<h2 class="help-section-title">{section.title}</h2>
<div class="help-text">{@html section.html}</div>
</section>
{/each}
</article>
</div>
</div>`
};
}

Fez('tpl-help', __fez_component_0);

export default __fez_component_0;
